module.exports = __webpack_public_path__ + "static/media/Jewku-Ezeike.b3b229dc.png";